import { Award01Icon } from '@hugeicons/react'

import { useNavigation } from '@/shared/hooks/useNavigation'
import { AnnouncementBanner } from '@/shared/ui/AnnouncementBanner'

import { useWinnerAnnouncements } from '../hooks/useWinnerAnnouncements'
import { buildPrizeSheetHref } from '../lib/prizeSheetSearch'

/**
 * Aviso de vitória no topo da tela inicial.
 *
 * Fica **acima da composição**, e não como um bloco do registro de blocos: a
 * tela inicial é montada pelo Produtor e tem um modo em que ela nem itera
 * blocos. Aviso de sistema não pode depender de o Produtor tê-lo incluído.
 *
 * Clicar e fechar têm o mesmo efeito sobre a ciência, por decisão de produto: o
 * aviso é o empurrão, e o registro permanente é a marca de ganho no card do
 * concurso. O que os separa é só o destino — clicar leva ao detalhe.
 */
export const WinnerAnnouncements = () => {
  const { announcements, acknowledge } = useWinnerAnnouncements()
  const { navigateTo } = useNavigation()

  if (announcements.length === 0) return null

  return (
    <div className="flex flex-col gap-2 pb-3">
      {announcements.map(announcement => (
        <AnnouncementBanner
          key={announcement.id}
          tone="success"
          icon={<Award01Icon size={17} variant="duotone" aria-hidden />}
          title="Você ganhou um concurso"
          description={announcement.name}
          dismissLabel={`Fechar aviso de ${announcement.name}`}
          onOpen={() => {
            acknowledge(announcement.id)
            navigateTo(buildPrizeSheetHref(announcement.id))
          }}
          onDismiss={() => acknowledge(announcement.id)}
        />
      ))}
    </div>
  )
}
